import { Box } from '@mui/material';

export const BrandIcon = () => {
  return (
    <Box
      sx={{
        width: 'auto',
        display: 'inline-block',
      }}
    >
      <img src="./content/images/mse-full-white.svg" alt="Logo" style={{ height: 60 }} />
    </Box>
  );
};
